module.exports = __webpack_public_path__ + "img/hums.8bfc8d63.png";